// tslint:disable: max-line-length
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { GlobalConstants } from 'src/app/services/globalConstants/global-constants.service';
import { GlobalFunctionsService } from 'src/app/services/globalFunctions/global-functions.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VisitaService } from 'src/app/services/visita/visita.service';
import { ProductoService } from 'src/app/services/producto/producto.service';
import { IExistenciaWeb } from 'src/app/interfaces/IExistenciaWeb';
import { IProductoWeb } from 'src/app/interfaces/IProductoWeb';

import { Plugins } from '@capacitor/core';
import { SucursalService } from 'src/app/services/sucursal/sucursal.service';
import { CarritoService } from 'src/app/services/carrito/carrito.service';
import { NavController, PopoverController, ToastController } from '@ionic/angular';
import { ISucursal } from 'src/app/interfaces/ISucursal';

const { Geolocation } = Plugins;

@Component({
  selector: 'app-carrito-tamano-popover',
  templateUrl: './carrito-tamano-popover.component.html',
  styleUrls: ['./carrito-tamano-popover.component.scss'],
})
export class CarritoTamanoPopoverComponent implements OnInit {

  //#region Propiedades

  public _appVersion: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;

  public _allSucursales: Array<ISucursal> = [];

  public _idProductoWeb: number;
  public _productoTxt: string;
  public _isLoading: boolean = true;

  public _sucursal: string = '0';

  public _idSucursalSeleccionada: string;
  public _nombreSucursalSeleccionada: string;

  public _idCarrito: number = 0;

  public _productoSeleccionado: boolean = false;
  public _productoSel: any;

  public _mensaje: string = '';

  public _allTamanos: Array<IExistenciaWeb>;

  public _latitud: any;
  public _longitud: any;

  public _tamanoSeleccionado: string;
  public _existenciaSeleccionado: string;
  public _precionSeleccionado: string;
  public _descuentoSeleccionado: any;
  public _subtotalSeleccionado: string;

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _router: Router,
              private _popoverCtrl: PopoverController,
              private _globalFunctionsSrv: GlobalFunctionsService,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              private _productoSrv: ProductoService,
              private _carritoSrv: CarritoService,
              private _sucursalSrv: SucursalService) {

    console.log('CarritoTamanoPopoverComponent >> constructor');

  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    console.log('CarritoTamanoPopoverComponent >> ngOnInit');
  }

  public async ionViewDidEnter() {
    this.validaCarrito();
    console.log('CarritoTamanoPopoverComponent >> ionViewDidEnter');

    this._appVersion = GlobalConstants.APP_VERSION;

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('CarritoTamaño', null, null,
        null, this._idProductoWeb, null, null,
        null, null,
        this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
    });

  }

  //#endregion

  //#region Eventos Botones

  public btnItemClick(item: IProductoWeb) {
  }

  public btnAddToCart(item: IProductoWeb) {
    this._tamanoSeleccionado = '';
    this._existenciaSeleccionado = '';
    this._precionSeleccionado = '';
    this._descuentoSeleccionado = '';
    this._subtotalSeleccionado = '';
    this._tamanoSeleccionado = item['TamanoTxt'];
    this._existenciaSeleccionado = item['CantidadExistencias'].toString();
    this._precionSeleccionado = item['PrecioPublico'].toString();
    this._descuentoSeleccionado = item['DescuentoPorcentaje'].toString();
    this._subtotalSeleccionado = item['Subtotal'].toString();
    this._productoSel = item;
    this._productoSeleccionado = true;
  }

  public btnGuardar(){
    if (!this._mensaje){
      this._mensaje = '';
      this._productoSel['MensajeTarjeta'] = null;
    }
    else{
      if (!this._mensaje){
        this._globalFunctionsSrv.showMessageToast('Debe ingresar el mensaje de la tarjeta');
      }
      else{
        this._productoSel['MensajeTarjeta'] = this._mensaje;
      }
    }

    this._usuarioSrv.setLocation(this._latitud, this._longitud)
    .then(() => {});

    this._carritoSrv.agregarProducto(this._sucursal, this._productoSel, this._idCarrito).subscribe(() => {
      this._productoSeleccionado = true;
      this._globalFunctionsSrv.showMessageToast('Se agregó el producto a su carrito de compras.');
      this._popoverCtrl.dismiss();
      this._router.navigate(['/carrito']);
    });
  }

  public back(){
    this._productoSeleccionado = false;
  }

  public close(){
    this._popoverCtrl.dismiss();
  }

  //#endregion

  //#region Eventos Controles

  public async refreshExistenciasWeb(){
    // Peticion a WebAPI
    this._isLoading = true;
    this._allTamanos = [];
    this._allTamanos['AllProductos'] = [];

    console.log('Sucursal >> ' + this._sucursal);
    console.log('ProductoWeb >> ' + this._idProductoWeb);

    this._productoSrv.getAllExistenciasWeb(this._sucursal, this._idProductoWeb).subscribe(() => {
      this._allTamanos = this._productoSrv.AllSucursales;

      console.log('Tamaños >> ' + JSON.stringify(this._allTamanos));

      this._allTamanos.forEach(itemSucursal => {
        itemSucursal.AllProductos.forEach(itemProducto => {
          itemProducto.Cantidad = 1;
          this.calcularSubtotalPartida(itemProducto);
        });
      });

      this._isLoading = false;
    });
  }
    //#endregion

  //#region Otros Metodos

  public async validaCarrito(){
    this._isLoading = true;
    const position = await Geolocation.getCurrentPosition({timeout: 30000, enableHighAccuracy: true});
    // this._latitud = 25.54912;
    // this._longitud = -103.45500;

    this._latitud = position.coords.latitude;
    this._longitud = position.coords.longitude;

    this._carritoSrv.getCarritoWeb().subscribe(() => {
      console.log('info de carro');
      console.log(this._carritoSrv.CurrentCarrito);

      if (this._carritoSrv.CurrentCarrito['IdCarrito'] > 0){
        this._idCarrito = this._carritoSrv.CurrentCarrito['IdCarrito'];
      }
      if (this._carritoSrv.CurrentCarrito['IdSucursal']){ // Ya hay Carrito creado
        this._idSucursalSeleccionada = this._carritoSrv.CurrentCarrito['IdSucursal'];
        this._nombreSucursalSeleccionada = this._carritoSrv.CurrentCarrito['NombreSucursal'];
        this._sucursal = this._carritoSrv.CurrentCarrito['IdSucursal'];

        this._productoSrv.getAllExistenciasWeb(this._carritoSrv.CurrentCarrito['IdSucursal'], this._idProductoWeb).subscribe(() => {
          this._allTamanos = this._productoSrv.AllSucursales;
          console.log(this._allTamanos);
          this._allTamanos.forEach(itemSucursal => {
            itemSucursal.AllProductos.forEach(itemProducto => {
              itemProducto.Cantidad = 1;
              this.calcularSubtotalPartida(itemProducto);
            });

          });
          this._isLoading = false;
        });

      }
      else{ // No hay Carrito creado
        this._sucursalSrv.getAllSucursales().subscribe(() => {
          const allSucursales = this._sucursalSrv.AllSucursales;

          console.info('Lat: ' + this._latitud);
          console.info('Lng: ' + this._longitud);

          // calcula distancias a cada sucursal
          allSucursales.forEach(itemSucursal => {
            if (itemSucursal.Lat && itemSucursal.Lng){
              const km = this._globalFunctionsSrv.distanceToPlace(this._latitud, this._longitud, itemSucursal.Lat, itemSucursal.Lng, 'K');

              if (km < 30){ // Solo agrega sucursales cercanas a 30 km
                this._allSucursales.push(
                  {
                    IdSucursal: itemSucursal.IdSucursal,
                    Nombre: itemSucursal.Nombre,
                    Distancia: km,
                    DistanciaText: km.toFixed(2)
                  });
              }
            }
          });

          // Busca sucursal mas cercana
          if (this._allSucursales.length > 0){
            this._allSucursales = this._allSucursales.sort((a, b) => a.Distancia - b.Distancia);
            this._sucursal = this._allSucursales[0].IdSucursal;
            // Peticion a WebAPI
            this._productoSrv.getAllExistenciasWeb(this._allSucursales[0].IdSucursal, this._idProductoWeb).subscribe(() => {
              this._allTamanos = this._productoSrv.AllSucursales;
              this._allTamanos.forEach(itemSucursal => {
                itemSucursal.AllProductos.forEach(itemProducto => {
                  itemProducto.Cantidad = 1;
                  this.calcularSubtotalPartida(itemProducto);
                });

              });
              this._isLoading = false;
            });
          }

        });
      }
    });
  }

  public calcularSubtotalPartida(item: IProductoWeb) {
    console.log('CajaPage >> calcularSubtotalPartida');

    // aplica descuento sobre Precio Publico
    if (item.IdTipoPromocion == GlobalConstants.PROMO_TIPO_PROMO_PORCENTAJE ||
      item.IdTipoPromocion == GlobalConstants.PROMO_TIPO_PROMO_PORCENTAJE_2o_PRODUCTO ||
      item.IdTipoPromocion == GlobalConstants.PROMO_TIPO_PROMO_CUMPLEAÑERO  ||
      item.IdTipoPromocion == GlobalConstants.PROMO_TIPO_PROMO_CUPON) { // descuento por porcentaje, se calcula sobre el subtotal
      item.DescuentoMontoTotal =  this._globalFunctionsSrv.bankers_round((item.Cantidad * item.PrecioPublico * item.DescuentoPorcentaje / 100), 2);

    } else if (item.IdTipoPromocion == GlobalConstants.PROMO_TIPO_PROMO_MONTO) { // descuento por monto, se calcula so
      item.DescuentoMontoTotal = this._globalFunctionsSrv.bankers_round(item.Cantidad * item.DescuentoMontoUnitario, 2);

    }
    item.Subtotal = this._globalFunctionsSrv.bankers_round((item.Cantidad * item.PrecioPublico) - item.DescuentoMontoTotal, 0);

    // recalcula impuestos
    const ieps: number = item.IEPSPorcentaje / 100;
    item.IEPSMonto = this._globalFunctionsSrv.bankers_round((item.Subtotal - (item.Subtotal / (1 + ieps))), 2);

    const iva: number = item.IVAPorcentaje / 100;
    item.IVAMonto = this._globalFunctionsSrv.bankers_round((item.Subtotal - (item.Subtotal / (1 + iva))), 2);

    item.SubtotalAntesDeImpuestos = item.Subtotal - item.IEPSMonto - item.IVAMonto;

    console.info('Cantidad >> ' + item.Cantidad);
    console.info('PrecioPublico >> ' + item.PrecioPublico);
    console.info('DescuentoMontoTotal >> ' + item.DescuentoMontoTotal);
    console.info('Subtotal >> ' + item.Subtotal);
    console.info('IEPSMonto >> ' + item.IEPSMonto);
    console.info('IVAMonto >> ' + item.IVAMonto);
    console.info('SubtotalAntesDeImpuestos >> ' + item.SubtotalAntesDeImpuestos);
  }

  //#endregion

}
